import { useState } from "react";
import { Badge, Button, Card, CardBody, Table } from "reactstrap";

import GroupCreationRequestService from "../Services/GroupCreationRequestService";
import { GroupCreationRequestDto } from "../types/GroupCreationRequest";
import RejectRequestModal from "../Admin/RejectRequestModal";

interface Props {

    requests: GroupCreationRequestDto[];

    refresh: () => void;

}

const GroupRequestTable = ({
    requests,
    refresh
}: Props) => {

    const [selectedRequest, setSelectedRequest] =
        useState<GroupCreationRequestDto | null>(null);

    const [modal, setModal] =
        useState(false);

    const approveRequest = async (
        requestId: string
    ) => {

        try {

            await GroupCreationRequestService.approve(
                requestId
            );

            refresh();

        }
        catch {

            alert("Unable to approve request.");

        }

    };

    const openReject = (
        request: GroupCreationRequestDto
    ) => {

        setSelectedRequest(request);

        setModal(true);

    };

    const rejectRequest = async (
        remarks: string
    ) => {

        if (!selectedRequest)
            return;

        try {

            await GroupCreationRequestService.reject(

                selectedRequest.groupCreationRequestId,

                {
                    remarks
                }

            );

            setModal(false);

            setSelectedRequest(null);

            refresh();

        }
        catch {

            alert("Unable to reject request.");

        }

    };

    const getStatusBadge = (
        status: string
    ) => {

        switch (status) {

            case "Pending":

                return (
                    <Badge color="warning">
                        Pending
                    </Badge>
                );

            case "Approved":

                return (
                    <Badge color="success">
                        Approved
                    </Badge>
                );

            case "Rejected":

                return (
                    <Badge color="danger">
                        Rejected
                    </Badge>
                );

            default:

                return (
                    <Badge color="secondary">
                        {status}
                    </Badge>
                );

        }

    };

    return (

        <>

            <div className="d-none d-md-block">
    <Table bordered hover responsive>

        <thead>
            <tr>
                <th>#</th>
                <th>Course</th>
                <th>Category</th>
                <th>Requested By</th>
                <th>Email</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
            </tr>
        </thead>

        <tbody>

            {requests.length === 0 && (
                <tr>
                    <td colSpan={8} className="text-center">
                        No Requests Found
                    </td>
                </tr>
            )}

            {requests.map((request, index) => (
                <tr key={request.groupCreationRequestId}>

                    <td>{index + 1}</td>

                    <td>{request.courseName}</td>

                    <td>{request.category}</td>

                    <td>{request.userName}</td>

                    <td>{request.email}</td>

                    <td>
                        {new Date(request.requestedAt).toLocaleDateString()}
                    </td>

                    <td>
                        {getStatusBadge(request.status)}
                    </td>

                    <td>

                        {request.status === "Pending" && (
                            <>
                                <Button
                                    color="success"
                                    size="sm"
                                    className="me-2"
                                    onClick={() =>
                                        approveRequest(request.groupCreationRequestId)
                                    }
                                >
                                    Approve
                                </Button>

                                <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => openReject(request)}
                                >
                                    Reject
                                </Button>
                            </>
                        )}

                    </td>

                </tr>
            ))}

        </tbody>

    </Table>
</div>

<div className="d-block d-md-none">

    {requests.length === 0 ? (

        <Card>
            <CardBody className="text-center">
                No Requests Found
            </CardBody>
        </Card>

    ) : (

        requests.map((request, index) => (

            <Card
                key={request.groupCreationRequestId}
                className="mb-3 shadow-sm"
            >

                <CardBody>

                    <div className="d-flex justify-content-between align-items-center mb-3">

                        <h5 className="mb-0">
                            {request.courseName}
                        </h5>

                        {getStatusBadge(request.status)}

                    </div>

                    <p>
                        <strong>#</strong> {index + 1}
                    </p>

                    <p>
                        <strong>Category:</strong> {request.category}
                    </p>

                    <p>
                        <strong>Requested By:</strong> {request.userName}
                    </p>

                    <p>
                        <strong>Email:</strong> {request.email}
                    </p>

                    <p>
                        <strong>Date:</strong>{" "}
                        {new Date(request.requestedAt).toLocaleDateString()}
                    </p>

                    {request.status === "Pending" && (

                        <div className="d-grid gap-2">

                            <Button
                                color="success"
                                onClick={() =>
                                    approveRequest(request.groupCreationRequestId)
                                }
                            >
                                Approve
                            </Button>

                            <Button
                                color="danger"
                                onClick={() => openReject(request)}
                            >
                                Reject
                            </Button>

                        </div>

                    )}

                </CardBody>

            </Card>

        ))

    )}

</div>

            <RejectRequestModal

                isOpen={modal}

                toggle={() => {

                    setModal(false);

                    setSelectedRequest(null);

                }}

                onSubmit={rejectRequest}

            />

        </>

    );

};

export default GroupRequestTable;